import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { shadows } from '../constants/shadows.js';

var wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-4arbjf-0"
})(["user-select:none;-webkit-tap-highlight-color:transparent;width:", ";cursor:", ";display:flex;flex-direction:", ";align-items:center;&:focus-visible{box-shadow:0 0 0 4px ", ";outline:2px solid ", ";outline-offset:0;}"], function (props) {
  return props.$width;
}, function (props) {
  return props.$disabled ? 'not-allowed' : 'pointer';
}, function (p) {
  return p.$labelPosition === 'top' ? 'column' : 'column-reverse';
}, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
});
var rail = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__rail",
  componentId: "sc-4arbjf-1"
})(["user-select:none;-webkit-tap-highlight-color:transparent;position:absolute;width:100%;cursor:", ";background-color:", ";height:", ";border-radius:", ";"], function (props) {
  return props.$disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.$disabled ? props.theme.slider.web.disabled : props.$color;
}, function (props) {
  return px2rem(props.theme.slider.web.rail.height);
}, function (props) {
  return props.theme.borders.radius;
});
var circle = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__circle",
  componentId: "sc-4arbjf-2"
})(["user-select:none;-webkit-tap-highlight-color:transparent;position:absolute;display:flex;cursor:", ";background-color:", ";width:", ";height:", ";margin-left:", ";border-radius:50%;outline:none;box-sizing:border-box;&:focus,&:hover{", "}"], function (props) {
  return props.$disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.$disabled ? props.theme.slider.web.disabled : props.$color;
}, function (props) {
  return px2rem(props.theme.slider.web.circle.diameter);
}, function (props) {
  return px2rem(props.theme.slider.web.circle.diameter);
}, function (props) {
  return "calc(".concat(px2rem(props.theme.slider.web.circle.diameter), " / -2)");
}, function (props) {
  return !props.$disabled && css(["border:2px solid ", ";box-shadow:", ";"], props.theme.slider.web.circle.focusHighlightColor, shadows.s);
});
/*#__PURE__*/styled.span.withConfig({
  displayName: "styles__valueIndicator",
  componentId: "sc-4arbjf-4"
})(["position:absolute;padding:", ";background-color:", ";color:", ";font-weight:bold;"], px2rem(8), function (props) {
  return props.theme.slider.web.valueIndicator.background;
}, function (props) {
  return props.theme.slider.web.valueIndicator.color;
});

export { circle, rail, wrapper };
